module.exports = __webpack_public_path__ + "static/img/banner.03416e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/banner.png
// module id = re7E
// module chunks = 1